import { motion } from "framer-motion";
import React from "react";
import Carouselcomp from "../../components/Home/Carouselcomp";
import { pageTransition, pageVariants } from "../../hooks/pagetransition";
import bylc from "../../images/bylc logo.jpg";
import icccad from '../../images/ICCCAD-logo(transparent4k).png';
import yo from '../../images/YO Logo Transparent.png';
import styles from "./Home.module.css";

const Home = () => {
  const pStyle = { fontWeight: "500", fontSize: "25px", margin: '40px' };
  return (
    <motion.div
      className="pb-3 text-center"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Carouselcomp />
      {/* <Carouselswip /> */}
      <div className="typewriter">
        <h1>Leading for a green world</h1>
      </div>
      <div>
        <p
          style={pStyle}
          className="text-center"
        >
          Our{" "}
          <span
            style={{
              // backgroundColor: "whitesmoke",
              // color: "black",
              // padding: "2px",
            }}
          >
            purpose
          </span>{" "}
          is to align your purpose in life towards creating a green and peaceful
          world
        </p>
      </div>
      <div>
        <div>
          <p
            style={pStyle}
            className="text-center"
          >
            We{" "}
            <span
              style={{
                // backgroundColor: "whitesmoke",
                // color: "black",
                // padding: "2px",
              }}
            >
              envision
            </span>{" "}
            a green world where we care about the environment and live a
            sustainable life
          </p>
          <p style={pStyle} className="text-center">
            We are Purpose-driven and we value Care, Collaborate, Empathy,
            Shared Success
          </p>
        </div>
      </div>
      <div>
        <h1>Partnership</h1>
        <br />
        <img src={bylc} width="100px" style={{margin: '5px 40px'}} alt="" />
        <img src={icccad} style={{backgroundColor: 'white', margin: '5px 20px', padding: '10px'}} width="100px" alt="" />
        <img src={yo} style={{backgroundColor: 'white', margin: '5px 20px', padding: '20px 5px'}} width="100px" alt="" />
        <br /><i style={{marginRight: '290px', fontSize: '10px'}}>Supported by (BYLC)</i>
      </div>
      <div className={styles.newsletter}>
          <h2 className="text-center">Newsletter</h2>
          <input
            type="email"
            name="newsletter"
            placeholder="Enter your email to subscribe"
          />
      </div>
    </motion.div>
  );
};

export default Home;
